// Copyright 2021 Sorama B.V.

import { DialogController } from "aurelia-dialog";
import { autoinject } from "aurelia-framework";
import { IProjectManagementService } from "services/Project/IProjectManagementService";

@autoinject
export class NewProjectDialog {
    private name = "New Project";
    private description: string;

    constructor(
        private readonly controller: DialogController,
        private readonly projectManagementService: IProjectManagementService
    ) {}

    protected cancel(): void {
        this.controller.cancel();
    }

    protected async create(): Promise<void> {
        const newProject = await this.projectManagementService.createProject(this.name, this.description);
        this.controller.ok(newProject);
    }
}
